import { rem } from 'polished';
import {
  ButtonStyledStyles,
  ButtonStyles,
} from '../../../_helpers/form/Button';
import styled, { css } from 'styled-components';

export const CategoryTextStyle = css`
  font-size: ${rem(14)};
`;

export const MoreButton = styled.a`
  ${ButtonStyles};
  ${ButtonStyledStyles};
  ${CategoryTextStyle};

  padding-top: 7px;
  padding-bottom: 7px;
`;
